<template>
    <div class="lg:w-1/2 sm:w-full text-center" id="scroll-to-multiselect">
        <p class="mb-1" v-text="label"></p>
        <multiselect
            v-model="question"
            :custom-label="contentForSearch"
            :options="faqAnswers"
            :searchable="true"
            :allow-empty="false"
            :multiple="false"
            :show-labels="false"
            openDirection="below"
            :placeholder="$t('FAQ_CAT_TYPE_KEYWORDS')"
            @search-change="handleSearchChange"
            @input="handleSelect">

            <!-- A single label is shown after pressing Enter -->
            <template slot="singleLabel" slot-scope="{ option }">
                <div class="option__desc">
                    <span class="option__title" v-text="option.title"></span>
                </div>
            </template>

            <!-- An option is shown while typing -->
            <template slot="option" slot-scope="{ option }">
                <div class="option__desc">
                    <span class="option__title" v-text="option.title"></span>
                </div>
            </template>

            <span slot="noResult">{{ $t('FAQ_SEARCH_SORRY') }}</span>

            <template slot="noOptions">{{ $t('FAQ_SEARCH_LIST_EMPTY') }}</template>

        </multiselect>
    </div>
</template>

<script>
import Multiselect from 'vue-multiselect';
import FaqService from '@/services/faq/FaqService';

let faqService = new FaqService();

export default {
    name: 'FaqSearch',
    components: { Multiselect },
    props: {
        label: {
            required: true,
            type: String,
        },
    },
    mounted: function() {
        this.getSearchQuestions();
    },
    data() {
        return {
            question: '',
            faqAnswers: [],
        };
    },
    computed: {
        isUserLoggedIn() {
            return this.$store.getters['auth/isUserLoggedIn'];
        },
    },
    methods: {
        /**
         * Get content for search (not visible as option in multiselect).
         *
         * @param {Object} title, answer
         *
         * @returns {String}
         */
        contentForSearch: ({ title, answer }) => `${title} ${answer}`,

        /**
         * Get search questions.
         *
         * @returns {Array}
         */
        getSearchQuestions() {
            faqService.getSearchQuestions().then((answers) => {
                this.faqAnswers = answers.filter(item => item.loggedIn === this.isUserLoggedIn);
            });
        },

        /**
         * Handles an event of select an option.
         *
         * @returns {void}
         */
        handleSelect() {
            this.$router.push(this.question.path);
        },

        /**
         * Handle the search query changes.
         *
         * @param {String} searchQuery
         *
         * @return {Array}
         */
        handleSearchChange(searchQuery) {
            if (searchQuery.length) {
                faqService.getUniqQuestions().then((answers) => {
                    this.faqAnswers = answers.filter(item => item.loggedIn === this.isUserLoggedIn);
                });
            } else {
                this.getSearchQuestions();
            }
        },
    },
};
</script>
